export namespace authTypes {
  export type Account = {
    _id: string;
    username: string;
    password?: string;
    /** When true — Instagram pages are connected via Facebook Login (user token flow). When false/undefined — via system user token flow. */
    isFacebookLogin?: boolean;
  };

  export type SignIn = (data: { username: string; password: string }) => Promise<{
    token: string;
  }>;
}
